/**
 * <CircularScore /> implements a circular widget that displays a percentage score
 * within a colored ring
 */
import React from 'react';

require('styles/utils/CircularScore.styl');

const classnames = require('classnames');

class CircularScore extends React.Component {
  /**
   * Return the style for <div.progress-ring-inner-fill /> based on the integer value `percentage`
   * @param  {integer} percentage The integer percentage of the score
   * @return {Object}            A style object for the <div.progress-ring-inner-fill />
   */
  innerFillStyle(percentage) {
    const deg = 360 * (percentage / 100);
    return {
      transform: `rotate(${deg}deg)`,
    };
  }

  render() {
    const percentage = parseInt(Math.floor(this.props.percentage));
    const innerFillStyle = this.innerFillStyle(percentage);
    const progressClassnames = classnames('progress-ring', {
      'greater-than-50': percentage > 50,
    });
    return (
      <div className="progress">
        <div className={progressClassnames}>
          {/** Ring body */}
          <div className="progress-ring-body">
            <div className="progress-ring-inner-fill" style={innerFillStyle}></div>
          </div>

          {/** Percentage text */}
          <div className="progress-percentage">
            <div className="progress-percentage-wrapper">
              <span>{this.props.percentage === null ? 'n/a' : percentage + '%'}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CircularScore;
